<template>
    <b-modal :id="modalName" title="Create New Batch Pick: " scrollable hide-footer>
        <b-table-simple hover small responsive bordered sticky-header="calc(100vh - 250px)" id="printMe">
            <b-thead v-if="!completed">
                <b-tr>
                    <b-th class="text-center" v-if="!completed">
                        <input type="checkbox" @click="checkAll" v-model="isCheckAll" :disabled="completed" v-if="openPicks.length" />
                    </b-th>
                    <b-th>Order #</b-th>
                    <b-th>Customer Name</b-th>
                    <b-th>Status</b-th>
                    <b-th>Payment Method</b-th>
                    <b-th>Subtotal</b-th>
                    <b-th>Tags</b-th>
                    <b-th>Order Notes</b-th>
                    <b-th>Sales Rep</b-th>
                </b-tr>
            </b-thead>
            <b-thead v-else>
                <b-tr>
                    <b-th>Order #</b-th>
                    <b-th>SKU</b-th>
                    <b-th class="text-center">QTY</b-th>
                    <b-th class="text-center">Available</b-th>
                    <b-th>Notes</b-th>
                    <b-th>Category</b-th>
                </b-tr>
            </b-thead>
            <b-tbody v-if="!completed">
                <b-tr v-for="(row, index) in openPicks" :key="index">
                    <b-td class="text-center" v-if="!completed">
                        <input type="checkbox" :id="'checkbox-' + row.id" :value="row.id" v-model="checked" :disabled="completed" v-if="openPicks.length" />
                    </b-td>
                    <b-td>{{ row.sales_order_number }}</b-td>
                    <b-td>{{ row.customer.name }}</b-td>
                    <b-td>{{ row.status }}</b-td>
                    <b-td>{{ row.payment_method }}</b-td>
                    <b-td>{{ row.subtotal }}</b-td>
                    <b-td>{{ generateTagString(row.sale_order_tag) }}</b-td>
                    <b-td>{{ row.internal_note }}</b-td>
                    <b-td>
                        <span v-if="row.sales_rep && row.sales_rep.name">{{ row.sales_rep.name }}</span>
                    </b-td>
                </b-tr>
            </b-tbody>
            <b-tbody v-else>
                <b-tr v-for="(row, index) in finalResult" :key="index">
                    <b-td>{{ row['Order #'] }}</b-td>
                    <b-td>{{ row['SKU'] }}</b-td>
                    <b-td class="text-center">{{ row['QTY'] }}</b-td>
                    <b-td class="text-center">{{ row['Available'] }}</b-td>
                    <b-td>{{ row['Notes'] }}</b-td>
                    <b-td>{{ row['Category'] }}</b-td>
                </b-tr>
            </b-tbody>
        </b-table-simple>

        <b-button type="submit" variant="success" @click="createBatch" :disabled="completed" v-if="openPicks.length">
            <span v-if="submitting">
                <b-spinner small type="grow"></b-spinner>
                Creating Batch...
            </span>
            <span v-else-if="completed">Completed</span>
            <span v-else>Create Batch</span>
        </b-button>

        <b-button type="submit" variant="outline-secondary" v-print="'#printMe'" :disabled="submittingPrint" v-if="completed">
            <span v-if="submittingPrint">
                <b-spinner small type="grow"></b-spinner>
                Printing...
            </span>
            <span v-else>Print</span>
        </b-button>

        <b-button type="submit" variant="outline-secondary" @click="exportExcel" :disabled="submittingExcel" v-if="completed">
            <span v-if="submittingExcel">
                <b-spinner small type="grow"></b-spinner>
                Downloading...
            </span>
            <span v-else>Excel</span>
        </b-button>
    </b-modal>
</template>
<script>
import * as XLSX from 'xlsx/xlsx.mjs';
export default {
    props: [],

    data() {
        return {
            modalName: 'modal-warehousing-batchpicks-create-batch-pick',
            submitting: false,
            submittingPrint: false,
            submittingExcel: false,
            completed: false,
            openPicks: [],
            isCheckAll: false,
            checked: [],
            finalResult: [],
            batchNo: ''
        }
    },

    methods: {
        generateTagString(tags) {
            let tagString = ''
            if (tags.length) {
                tags.forEach((row) => {
                    if (tagString.length) {
                        tagString += ' / ' + row.orders_tag.name
                    } else {
                        tagString += row.orders_tag.name
                    }
                })
            }

            return tagString
        },

        exportExcel() {
            var invoicesWS = XLSX.utils.json_to_sheet(this.finalResult)

            // A workbook is the name given to an Excel file
            var wb = XLSX.utils.book_new() // make Workbook of Excel

            // add Worksheet to Workbook
            // Workbook contains one or more worksheets
            XLSX.utils.book_append_sheet(wb, invoicesWS, 'Batch List') // invoices list is name of Worksheet


            // export Excel file
            XLSX.writeFile(wb, 'Batch_' + this.batchNo + '_Export.xlsx')

        },

        checkAll() {
            this.isCheckAll = !this.isCheckAll;
            this.checked = [];
            if (this.isCheckAll) { // Check all
                for (var key in this.openPicks) {
                    this.checked.push(this.openPicks[key].id);
                }
            }
        },

        getOpenPicks() {
            let url = 'api/warehousing/batchpick/openpicks'
            axios.get(url, {})
                .then((res) => {
                    this.openPicks = res.data.open
                    this.checkAll()
                }, () => {
                    this.has_error = true
                })
        },

        createBatch() {
            this.submitting = true
            let url = 'api/warehousing/batchpick/createbatch'
            axios.post(url, {
                checked: this.checked
            })
                .then((res) => {
                    if (res.data.status == 'success') {
                        this.batchNo = res.data.batchNo
                        this.completed = true

                        this.compileFinalResult()

                        this.showAlertBox('success', 'Batch Created', 'Batch created successfully!')
                        // this.$emit('updateRowItems', res.data.rows)
                        // this.closeModal(this.modalName)
                    } else {
                        // this.showAlertBox('error', 'Invalid Content', 'Pasted contents not in CSV tabbed delimited format. Please try again!')
                    }

                    this.submitting = false
                }, () => {
                    this.has_error = true
                })
        },

        compileFinalResult() {
            // generate final table
            this.openPicks.forEach((row) => {
                if (this.checked.includes(row.id)) {
                    row.sale_order_item.forEach((r) => {
                        this.finalResult.push({
                            'Order #': row.sales_order_number,
                            'SKU': r.item.sku,
                            'QTY': r.quantity,
                            'Available': r.item.qty_available,
                            'Notes': r.notes,
                            'Category': r.item.category ? r.item.category.name : ''
                        })
                    })
                }
            })

            this.finalResult = _.sortBy(this.finalResult, ['SKU', 'Order #'])
        }
    },

    mounted() {
        this.getOpenPicks()
    }
}
</script>
<style lang="scss">
#modal-warehousing-batchpicks-create-batch-pick {
    .modal-content {
        font-size: 10pt;
    }

    .modal-dialog {
        width: 75vw !important;
        max-width: 75vw !important;
    }
}
</style>
